/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import * as auth from '../redux/AuthRedux'
import * as component from '../../../components/redux/componentRedux'
import {register} from '../redux/AuthCRUD'
import {Link, useLocation} from 'react-router-dom'
import {FormChangePassword} from './FormChangePassword'
import {Alerts, OtpInput} from '../../../components'
import {enableAuthenticator, verifyEmail} from '../apis'
import {CreatePinCode} from './CreatePinCode'
import {messageError} from '../../../utils'
import QRCode from 'react-qr-code'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

type Props = {
  userId: string
  code: string
}

const initialValues = {
  userId: '',
  code: '',
  email: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
}

const registrationSchema = Yup.object().shape({
  // firstname: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('First name is required'),
  // email: Yup.string()
  //   .email('Wrong email format')
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Email is required'),
  // lastname: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Last name is required'),
  // password: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Password is required'),
  // changepassword: Yup.string()
  //   .required('Password confirmation is required')
  //   .when('password', {
  //     is: (val: string) => (val && val.length > 0 ? true : false),
  //     then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
  //   }),
  // acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
})

export function Registration({userId, code}: Props) {
  const [loading, setLoading] = useState(false)
  const [isChangePassword, setChangePassword] = useState(false)
  const [isUseOtp, setUseOtp] = useState(false)
  const [loginType, setLoginType] = useState('')
  const [qrCode, setQrCode] = useState('')
  const dispatch = useDispatch()
  let location: any = useLocation()
  let email = location.state?.email
  let message = location.state?.message
  let errorType = location.state?.errorType

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
    },
  })

  const handleConfirmAccount = () => {
    setLoading(true)
    let data = {
      model: {
        userId: initialValues.userId,
        code: initialValues.code,
      },
    }
    verifyEmail(data).then((res: any) => {
      if (res && !res.isError) {
        setLoading(false)
        setChangePassword(true)
      }
    })
    // setTimeout(() => {
    //   setLoading(false)
    //   setChangePassword(true)
    // }, 500)
  }

  const handleChangePasswordSubmit = (type: string) => {
    setLoginType(type)
    if (type == 'GoogleAuthenticator' || type == '1') {
      getUrlQrCode(userId)
    }

    if (type == '2' || type == 'PinCode') {
      setUseOtp(true)
    }
  }

  const handleGgAuthNext = () => {
    setUseOtp(true)
  }

  const getUrlQrCode = (param: string) => {
    dispatch(component.actions.showBackdrop({show: true}))
    enableAuthenticator(param)
      .then((res: any) => {
        if (res && !res.isError) {
          setQrCode(res.data.authenticatorUri)
          dispatch(component.actions.showBackdrop({show: false}))
        }
      })
      .catch((error) => {
        dispatch(
          component.actions.writeAlert({
            show: true,
            type: 'error',
            message: messageError(error.response),
          })
        )
        dispatch(component.actions.showBackdrop({show: false}))
      })
  }

  useEffect(() => {
    if (errorType) {
      if (errorType == '5') {
        getUrlQrCode(email)
        setLoginType('1')
      }
    }
  }, [errorType])

  useEffect(() => {
    if (userId && code) {
      initialValues.userId = userId
      initialValues.code = code
    }
  }, [userId, code])

  return (
    <>
      <Alerts />
      {!isChangePassword && !errorType && (
        <>
          <div className='mb-10 text-center'>
            <h1 className='text-dark mb-3'>Kích hoạt tài khoản</h1>
          </div>
          <div className='text-center'>
            <button
              onClick={handleConfirmAccount}
              id='kt_sign_up_submit'
              className='btn btn-lg btn-primary w-100 mb-5'
            >
              {!loading && <span className='indicator-label'>Kích hoạt</span>}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Vui lòng đợi...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </>
      )}
      {((isChangePassword && !isUseOtp && !qrCode) || (errorType && errorType == '2')) && (
        <>
          <div className='mb-8 text-center'>
            <h1 className='text-dark mb-3'>Đổi mật khẩu</h1>
          </div>
          <FormChangePassword
            userId={initialValues.userId}
            email={email ? email : initialValues.email}
            isRegister={email ? false : true}
            handleChangePasswordSubmit={handleChangePasswordSubmit}
          />
        </>
      )}
      {qrCode && !isUseOtp && (
        <>
          <div className='text-center mb-8'>
            <h1 className='text-dark mb-3'>QrCode</h1>
            <p style={{fontStyle: 'italic', color: 'red', fontSize: '15px'}}>
              Vui lòng sử dụng ứng dụng xác thực Google Authenticator dành cho Android và IOS để
              quét mã QR bên dưới. Sau đó ấn tiếp tục và nhập mã PIN hiện ra trên ứng dụng.
            </p>
          </div>
          <div className='text-center'>
            <QRCode value={qrCode} size={136} />
          </div>
          <div className='d-flex flex-wrap justify-content-center pb-lg-0 mt-8'>
            <button
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              onClick={handleGgAuthNext}
            >
              Tiếp tục
            </button>
          </div>
        </>
      )}
      {isUseOtp && <CreatePinCode type={loginType} userId={userId ? userId : email} />}
      {/* {isUseOtp && (
        <>
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button id='kt_password_reset_submit' className='btn btn-lg btn-primary fw-bolder me-4'>
              <span className='indicator-label'>Hoàn thành</span>
              {loading && (
                <span className='indicator-progress'>
                  Vui lòng đợi...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
            <button
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              onClick={handlePrevStep}
            >
              Quay lại
            </button>
          </div>
        </>
      )} */}
    </>
  )
}
